import { ProgrammeDetails } from "@customTypes/programmeDetails";

export const filterProgrammesByDateAsc = (programmes: ProgrammeDetails[]) => {
  return programmes.sort((a, b) => {
    return (
      new Date(a.programmeImportData[0].programmeStartDate).getTime() -
      new Date(b.programmeImportData[0].programmeStartDate).getTime()
    );
  });
};
